import { AxiosResponse } from 'axios'
import { IActivationRequest, ICreateSellerRequest, IPhoneLoginTokensResponse, IRecoveryRequest, IRefreshResponse, IRequestEmailAttachCodeRequest, IRequestEmailAttachCodeResponse, IRequestPhoneLoginEmailCodeRequest, IRequestPhoneLoginEmailCodeResponse, IRequestPhoneLoginRequest, IRequestPhoneLoginResponse, IResendPhoneLoginRequest, ISendEmailRequest, ISendPhoneCodeRequest, ISendPhoneCodeResponse, ISignInRequest, ISignInResponse, ISignUpRequest, ISignUpResponse, IVerifyEmailAttachCodeRequest, IVerifyEmailAttachCodeResponse, IVerifyPasswordRecoveryCodeRequest, IVerifyPasswordRecoveryCodeResponse, IVerifyPhoneLoginEmailCodeRequest, IVerifyPhoneLoginRequest, IVerifyPhoneLoginResponse, IVerifyPhoneRequest, IVerifyPhoneResponse } from 'models/auth'
import { getNormalizedFormData } from 'shared/utils/getNormalizedFormData'
import { api, privateApi, temporaryApi } from '.'

export const authApi = {
  signUp(data: ISignUpRequest): Promise<AxiosResponse<ISignUpResponse>> {
    return api.post<ISignUpResponse>('signUp', data)
  },
  activateEmail(data: IActivationRequest): Promise<AxiosResponse> {
    return api.post('activate', data)
  },
  createSeller(token: string, data: ICreateSellerRequest): Promise<AxiosResponse> {
    const formData = getNormalizedFormData(data)
    return temporaryApi.post('seller', formData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
  },
  signIn(data: ISignInRequest): Promise<AxiosResponse<ISignInResponse>> {
    return api.post<ISignInResponse>('login', data)
  },
  loginTelegramWebApp(initData: string): Promise<AxiosResponse<ISignInResponse>> {
    return api.post<ISignInResponse>('login/telegram-webapp', { init_data: initData })
  },
  checkAuth(): Promise<AxiosResponse<IRefreshResponse>> {
    return api.get<IRefreshResponse>('refresh')
  },
  recoverPasswordSendCode(data: ISendEmailRequest): Promise<AxiosResponse> {
    return api.post('send-email', data)
  },
  verifyPasswordRecoveryCode(data: IVerifyPasswordRecoveryCodeRequest): Promise<AxiosResponse<IVerifyPasswordRecoveryCodeResponse>> {
    return api.post<IVerifyPasswordRecoveryCodeResponse>('recovery-password/verify-code', data)
  },
  recoveryPassword(data: IRecoveryRequest): Promise<AxiosResponse> {
    return api.post('recovery-password', data)
  },
  logout(): Promise<AxiosResponse> {
    return api.get('logout')
  },
  sendPhoneCode(data: ISendPhoneCodeRequest): Promise<AxiosResponse<ISendPhoneCodeResponse>> {
    return privateApi.post<ISendPhoneCodeResponse>('phone/send-code', data)
  },
  verifyPhone(data: IVerifyPhoneRequest): Promise<AxiosResponse<IVerifyPhoneResponse>> {
    return privateApi.post<IVerifyPhoneResponse>('phone/verify', data)
  },
  requestPhoneLogin(data: IRequestPhoneLoginRequest): Promise<AxiosResponse<IRequestPhoneLoginResponse>> {
    return api.post<IRequestPhoneLoginResponse>('phone/login/request', data)
  },
  verifyPhoneLogin(data: IVerifyPhoneLoginRequest): Promise<AxiosResponse<IVerifyPhoneLoginResponse>> {
    return api.post<IVerifyPhoneLoginResponse>('phone/login/verify', data)
  },
  resendPhoneLoginCode(data: IResendPhoneLoginRequest): Promise<AxiosResponse<ISendPhoneCodeResponse>> {
    return api.post<ISendPhoneCodeResponse>('phone/login/resend', data)
  },
  requestPhoneLoginEmailCode(data: IRequestPhoneLoginEmailCodeRequest): Promise<AxiosResponse<IRequestPhoneLoginEmailCodeResponse>> {
    return api.post<IRequestPhoneLoginEmailCodeResponse>('phone/login/email/request', data)
  },
  verifyPhoneLoginEmailCode(data: IVerifyPhoneLoginEmailCodeRequest): Promise<AxiosResponse<IPhoneLoginTokensResponse>> {
    return api.post<IPhoneLoginTokensResponse>('phone/login/email/verify', data)
  },
  requestEmailAttachCode(data: IRequestEmailAttachCodeRequest): Promise<AxiosResponse<IRequestEmailAttachCodeResponse>> {
    return privateApi.post<IRequestEmailAttachCodeResponse>('email/attach/request', data)
  },
  verifyEmailAttachCode(data: IVerifyEmailAttachCodeRequest): Promise<AxiosResponse<IVerifyEmailAttachCodeResponse>> {
    return privateApi.post<IVerifyEmailAttachCodeResponse>('email/attach/verify', data)
  }
}
